import axios from "axios";
import api from "@/store/modules/api";

export default {
  state: {
    decks: [],
    selected_deck: {},
    steps: [
      {
        name: 'Intro',
        details:
          `Pentru o idee aflata la inceput, un VC nu asteapta perfectiune. 
          El trebuie sa gaseasca raspunsurile la urmatoarele intrebari:
        `,
        description:
          `• Adreseaza business-ul propus o durere reala care are nevoie de o rezolvare?
          • Este o nevoie serioasa?
          • Este solutia propusa convingatoare, captivanta, care atrage atentia consumatorului?
          • Este ideea scalabila?
          • Este echipa propusa capabila sa realizeze acest produs?
          • Poate deveni acest proiect big business 10x - 100x ROI?
          `
      },
      {
        name: 'Problema',
        details: `Descrie scurt dar coerent si clar problema pe care ai identificat-o si pe care vrei sa o adresezi in business-ul propus. 
                  Adauga context, tine cont ca cititorul nu stie nimic din ce stii tu.`,
        textarea: true
      },
      {
        name: 'Solutia',
        details: 'Descrie solutia cat mai obiectiv, adauga context, tine cont ca cititorul nu stie nimic din ce stii tu.',
        textarea: true
      },
      {
        name: 'Produs',
        details: `Descrie ce face produsul tau (app), include wireframe sau prototip (ideal).
        Adauga context, tine cont ca cititorul nu stie nimic din ce stii tu.`,
        textarea: true
      },
      {
        name: 'Oportunitatea de Marketing',
        details: `Descrie dimensiunea pietei pentru business-ul/produsul tau.`,
        description:
          `Adauga estimari TAM/SAM/SOM
        • TAM - Piata totala, cat de mare este visul
        • SAM - Piata ta (cine are nevoie de produsul tau, de solutia ta specifica)
        • SOM - Piata reala (cati clienti poti aduce efectiv)`,
        textarea: true
      },
      {
        name: 'Business model',
        description:
          `• Subscription? 
          • Freemium?
          • Coaching upselling?
          `,
        textarea: true
      },
      {
        name: 'Traction',
        details: ``,
        description:
          `• Waitlist
          • Surveys
          • Early users
          • Interviews
          `,
        textarea: true
      },
      {
        name: 'GTM - Go To Market Strategy',
        details: `Cum vom aduce users?`,
        description:
          `(tiktok, insta, fb, ...)`,
        textarea: true
      },
      {
        name: 'Competitie',
        details: `Ce solutii/produse/app-uri exista deja in acest sens?`,
        description:
          `CE TE DIFERENTIAZA? (critical)`,
        textarea: true
      },
      {
        name: 'Echipa',
        details: `Descrie echipa implicata.`,
        description:
          `Raspunde la intrebarea "De ce eu/noi?"`,
        textarea: true
      },
      {
        name: 'Viziune',
        details: `Fii clar, scurt si la obiect.`,
        description:
          `O propozitie simpla si usor de memorat.`,
        textarea: true
      },
      {
        name: 'Financiar',
        details: `Proiectie simple pe 3-5 ani.`,
        description:
          `Cati revenue o sa genereze?`,
        textarea: true
      },
      {
        name: 'Cerinta VC',
        details: `Ce anume vrei de la VC?`,
        description:
          `Scrie aici cati bani si ce resurse doresti, si pentru ce o sa folosesti banii.`,
        textarea: true
      },
      {
        name: 'Ce mai trebuie pe langa PitchDeck',
        details: ``,
        description:
          `• Materiale de produs (wireframe, prototip, etc.). Materialele vizuale conteaza foarte mult.
          • One Pager - optional dar puternic (VC scaneaza de obicei aceasta pagina inainte). O pagina care sa contina urmatoarele elemente:
          - Problema
          - Solutia
          - Market
          - Echipa
          - Cerinte VC
          • Data Room (doar daca se cere) bine de avut:
          - market research
          - user interviews
          - surveys
          - product roadmap
          - financial assumptions
          `,
      },
      {
        name: 'Ce evalueaza VC in spatele cortinei',
        details: ``,
        description:
          `1. Market size
          - can this become a +100M euro company?
          2. Diferentiere
          - deja exista app-uri in acest domeniu, deci vor intreba De ce ...?, sau Ce este unic la solutia voastra?
          3. Founder market fit (povestea)
          - De ce voi?
          - Povestea personala
          - Deep understanding of the business
          - acces pentru early users
          4. Scalabilitate
          VC doresc:
          - potential global
          - subscription revenue model
          - high retention`,
      },
    ],
    start_steps: [
      {
        name: 'Validarea ideii',
        description:
          `• ruleaza interviuri
          • intelegerea si documentarea real pain point`,
      },
      {
        name: 'Defineste produsul',
        description:
          `• descrie in clar produsul
          • creeaza wireframes`,
      },
      {
        name: 'Creeaza PitchDeck',
        description:
          `• curat, vizual, fara mult text`,
      },
      {
        name: 'Creaza un prototip simplu',
        description:
          `• clickable flow`,
      },
      {
        name: 'Pregateste-ti povestea',
        description:
          `• de ce conteaza proopunerea ta
          • de ce acum
          • de ce eu`,
      },
      {
        name: 'Trimite catre VC',
        description:
          `• email
          • include prototip link`,
      },
      {
        name: 'Ce sa NU FACI',
        description:
          `• sa adaugi prea mult text in slides;
          • sa nu detaliezi in clar ce te diferentiaza;
          • sa ignori competitia
          • sa nu adaugi/sa uiti plan de monetizare
          • sa adaugi o viziune supra complicata`,
      },
    ]
  },
  mutations: {
    SET_PITCHDECK_STATE (state, { key, value }) {
      state[key] = value;
    },
    SELECT_DECK (state, deck_id) {
      state.selected_deck = state.decks.find(deck => deck._id === deck_id);
      ;
    },
    ADD_DECK (state, deck) {
      state.decks.push(deck);
    },
  },
  actions: {
    async get_pitchdecks ({ commit }) {
      try {
        const { data } = await axios.get(api.pitchdecks);
        commit('SET_PITCHDECK_STATE', { key: 'decks', value: data });
        commit('SET_PITCHDECK_STATE', { key: 'selected_project_id', value: data[0]._id });
      } catch (err) {
        console.log(err)
      }
    },
    async create_deck ({ commit }, name) {
      try {
        const { data } = await axios.post(api.pitchdecks, { name });
        commit('ADD_DECK', data);
      } catch (err) {
        console.log(err)
      }
    },
    async save_step_details ({ state, commit }, { step_content, step_name }) {
      try {
        const url = `${api.pitchdecks}/update-step-content/${state.selected_deck._id}`;
        await axios.put(url, { step_content, step_name });
      } catch (err) {
        console.log(err)
      }
    },
  }
}